module.exports = __webpack_public_path__ + "static/media/icon_switch.2049d4fd.svg";